import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/img6.png';
import _imports_1 from '@/assets/img7.png';
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "service"
};
const _hoisted_3 = {
  class: "flex"
};
const _hoisted_4 = {
  class: "list"
};
const _hoisted_5 = {
  class: "item-title"
};
const _hoisted_6 = {
  class: "item-text"
};
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const list = ref([{
      title: '精细化发券:',
      content: '立足省、市、县、区及各部门差异化业务需求，定制开发发券功能与核销逻辑。'
    }, {
      title: '攻略化促销:',
      content: '整合政企各类券种，打造促消费长链攻略，引导用户实现吃、娱、住、行多维一体消费。'
    }, {
      title: '立体化风控:',
      content: '实时侦测拦截订单，立体监控商家与用户异常行为，实现分秒级多维度刷单、套现预警。'
    }, {
      title: '数据安全与分析:',
      content: '促消费数据本地化留存，系统搭载高等级数据防护插件，数据明细调取需经相关部门审批并出具调取函。依托先进大数据技术，对各地促消费数据进行实时全面分析，专人跟进并定期汇报。'
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "banner"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createStaticVNode("<div class=\"about\" data-v-d184e824><div class=\"us-title\" data-v-d184e824>ABOUT US</div><h3 class=\"title\" data-v-d184e824>关于我们</h3><div class=\"content-title\" data-v-d184e824> 品浙消费平台介绍 </div><div class=\"line\" data-v-d184e824></div><div class=\"content-text\" data-v-d184e824> “品浙消费”是浙江专属促消费平台，以 “政府引导、平台承接、全民普惠” 为使命，连接消费资源，助力政、企、民三方，构建线上线下 </div><img src=\"" + _imports_0 + "\" width=\"100%\" height=\"569px\" alt=\"\" data-v-d184e824></div>", 1)), _createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "us-title"
      }, "SERVICE AND SUPPORT", -1)), _cache[2] || (_cache[2] = _createElementVNode("h3", {
        class: "title"
      }, "服务与保障", -1)), _createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        style: {
          "background-color": "#DCF8FF"
        }
      }, [_createElementVNode("img", {
        src: _imports_1,
        style: {
          "width": "483px",
          "height": "auto"
        },
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.title
        }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.content), 1)]);
      }), 128))])])])])], 64);
    };
  }
};